import type { OnboardingSchema, OnboardingSchemaDTO } from "@akina/domain";
import { onboardingSchemaMapper } from "../mappers";
import { type ApiConfiguration, ApiMethod } from "./shared";

export const onboardingApi = (config: ApiConfiguration) => ({
  async onboard(): Promise<void> {
    await config.httpService.fetch<{ presigned_url?: string }>({
      method: ApiMethod.POST,
      url: config.endpoints.onboarding,
    });
  },
  async getStatus(params: { onboardingId: string }): Promise<OnboardingSchema> {
    const response = await config.httpService.fetch<OnboardingSchemaDTO>({
      method: ApiMethod.GET,
      url: config.endpoints.onboardingStatus(params.onboardingId),
    });
    return onboardingSchemaMapper.toDomain(response);
  },
});
